import React from 'react';
import { IRouter } from '@routers/interface';
import { AppstoreOutlined } from '@ant-design/icons';
import { PERMISSION_DEVICE } from '@modules/device/constants';

export const routerDevice: IRouter = {
  path: '/device',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'device.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  menu: {
    icon: <AppstoreOutlined />,
  },
  permissionCode: PERMISSION_DEVICE.VIEW,
};
